/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPauseFilled: {
  name: 'pause-filled';
  data: string;
} = {
  name: 'pause-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.643 3.069a1.118 1.118 0 0 0-.343.229C5.973 3.624 6 2.855 6 12c0 9.144-.026 8.376.299 8.701.28.281.385.299 1.701.299s1.421-.018 1.701-.299c.325-.325.299.443.299-8.701s.026-8.376-.299-8.701c-.282-.282-.383-.299-1.718-.296-.945.003-1.196.015-1.34.066m8 0a1.118 1.118 0 0 0-.343.229c-.327.326-.3-.443-.3 8.702 0 9.144-.026 8.376.299 8.701.28.281.385.299 1.701.299s1.421-.018 1.701-.299c.325-.325.299.443.299-8.701s.026-8.376-.299-8.701c-.282-.282-.383-.299-1.718-.296-.945.003-1.196.015-1.34.066"/></svg>`
};
